module.exports = __webpack_public_path__ + "static/img/qrcode.8424fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qrcode.jpg
// module id = KfG6
// module chunks = 1